module.exports = __webpack_public_path__ + "static/media/7de87fb1-de1f-45c3-adef-b60ed40c7beb.1e06b71b.ttf";